export const TaleDashbaordMainCard = ({ className, children, ...props }) => {
  return (
    <div
      className={`w-full min-h-[calc(100vh-100px)] bg-white rounded-2xl p-2 md:p-5 ${className ?? ""}`}
      {...props}
    >
      {children}
    </div>
  );
};
